import axios from "axios";
import authHeader from '../../../authheader'

const PLSAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsApplication";

const getViolation = (applicationId) => {
    return axios.get(`${PLSAPPLICATIONURL}/violation`, { headers: authHeader(), params: { applicationId }  });
}
const postViolation = (data) => {
    return axios.post(`${PLSAPPLICATIONURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}